export const PRIVACY_LINK_EN_CA = 'https://www.thenorthface.com/en_ca/help/privacy.html';
export const PRIVACY_LINK_FR_CA = 'https://www.thenorthface.com/fr_ca/help/privacy.html';

export const TERMS_AND_CONDITIONS_LINK_EN_CA = 'https://www.thenorthface.com/en_ca/help/the-north-face-healthcare-workers-discount-program.html';
export const TERMS_AND_CONDITIONS_LINK_FR_CA = 'https://www.thenorthface.com/fr_ca/help/the-north-face-healthcare-workers-discount-program.html';
